"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const d3 = __importStar(require("d3"));
const lodash_1 = __importDefault(require("lodash"));
const resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
const canvas_1 = require("canvas");
const LineChart_1 = __importDefault(require("../LineChart"));
const drawCanvas_1 = require("../LineChart/drawCanvas");
const helpers_1 = require("../LineChart/helpers");
require("./SmallMultiples.scss");
const Expander_1 = __importDefault(require("../Expander"));
const common_module_scss_1 = __importDefault(require("../../styles/common.module.scss"));
const constants_1 = require("../../constants");
const chart_helpers_1 = require("../../util/chart.helpers");
const CanvasDrawer_1 = __importDefault(require("../../util/CanvasDrawer"));
const error_1 = require("../error");
const SourcesAndFootnotes_1 = __importDefault(require("../SourcesAndFootnotes"));
const DEFAULT_HEIGHT_TO_WIDTH = 1 / 2;
const MIN_MULTIPLE_HEIGHT = 150;
class SmallMultiples extends Expander_1.default {
  constructor(container, cssPrefix) {
    super(container, 1000, 300, cssPrefix || 'small-multiples', true);
    this.chartType = constants_1.CHART_TYPES.SmallMultiples;
    this.cssPrefix = cssPrefix || 'small-multiples';
    this.margins = {
      top: 20,
      bottom: 50,
      left: 10,
      right: 10,
      minRightLabel: 0,
      maxRightLabelRatio: 0.4
    };
    this.betweenPadding = 0.1;
    this.columns = 2;
    this.charts = {};
    if (container === undefined) {
      this.draw = this.drawCanvas;
      return;
    }
    this.title = container.insert('div', '.expandable').classed('chart-title', true);
    this.subtitle = container.insert('div', '.expandable').classed('chart-subtitle', true);
    this.container = container;
    this.sourceContainer = container.append('div');
    this.sources = new SourcesAndFootnotes_1.default(this.sourceContainer);
    this.initExpand();
    this.svg.remove();
    this.expandable = container.select('div.expandable');
    this.content = container.select('div.expandable').insert('div', '.chart-expander').classed(this.cssPrefix, true);
    error_1.initError.call(this);
    this.ro = new resize_observer_polyfill_1.default(entries => {
      entries.forEach(entry => {
        const {
          width: containerWidth
        } = entry.contentRect;
        if (this.width === containerWidth || containerWidth === 0) {
          return;
        }
        requestAnimationFrame(() => {
          this.width = containerWidth;
          this.redrawContent();
        });
      });
    });
    this.ro.observe(container.node());
  }
  async data(promises) {
    const fetched = await error_1.tryChartPromises.call(this, promises);
    if (!fetched) return null;
    const {
      data,
      topMetrics,
      parent
    } = fetched;
    const filtered = data.filter(d => {
      const dArray = lodash_1.default.flattenDeep([d]);
      return dArray.some(dd => dd.metric.data && dd.metric.data.length > 0);
    });
    return {
      data: filtered,
      topMetrics,
      parent
    };
  }
  createMultiples(enter, params) {
    const obj = this;
    return enter.append('div').classed('small-multiple', true).each(function (d) {
      const width = obj.chartWidth();
      const height = width * SmallMultiples.heightToWidthRatio(width, params);
      obj.charts[SmallMultiples.id(d)] = new LineChart_1.default(d3.select(this), true, width, height);
    });
  }
  destroyMultiples(exit) {
    return exit.each(d => {
      delete this.charts[SmallMultiples.id(d)];
    }).remove();
  }
  chartWidth() {
    let width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.width;
    return width / this.columns;
  }
  static heightToWidthRatio(width, params) {
    return Math.max(MIN_MULTIPLE_HEIGHT / width, params.heightToWidthRatio || DEFAULT_HEIGHT_TO_WIDTH);
  }
  height(data, params) {
    let width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.width;
    const ratio = SmallMultiples.heightToWidthRatio(this.chartWidth(width), params);
    const titleBottomPadding = 20;
    const titleLineHeightMultiplier = 1.25;
    const subchartFontSize = 16;
    const mainTitleFontSize = params.titleFontSize;
    const rows = Math.ceil(data.length / this.columns);
    const chartHeight = this.chartWidth(width) * ratio;
    return (chartHeight + subchartFontSize * titleLineHeightMultiplier) * rows + titleBottomPadding + mainTitleFontSize * titleLineHeightMultiplier;
  }
  transform(d, i, params) {
    const x = this.chartWidth() * this.betweenPadding + this.chartWidth() * (1 + this.betweenPadding) * (i % this.columns);
    const y = this.chartWidth() * (params.heightToWidthRatio + this.betweenPadding) * Math.floor(i / this.columns);
    return `translate(${x}, ${y})`;
  }
  static id(d) {
    return Array.isArray(d) ? d.map(v => `${v.metric.id}-${v.metric.name}-${v.metric.geo_id}`).join() : `${d.metric.id}-${d.metric.name}-${d.metric.geo_id}`;
  }
  getDrawParams(_ref, allData, i) {
    let {
      data,
      parent,
      options
    } = _ref;
    const resolvedChartStyle = (0, helpers_1.getResolvedChartStyle)('default', {});
    const margins = {
      ...((resolvedChartStyle === null || resolvedChartStyle === void 0 ? void 0 : resolvedChartStyle.margins) ?? LineChart_1.default.margins),
      ...this.margins
    };
    const startDate = options.startDate || options.startYear;
    const endDate = options.endDate || options.endYear;
    const defaultParams = (0, chart_helpers_1.getDefaultDrawParams)({
      data,
      parent,
      options
    }, margins);
    const flatData = (0, chart_helpers_1.allDataPoints)(allData, startDate, endDate, data[0] ? data[0].metric.xType : 'years');
    const xDomain = d3.extent(flatData, d => d.key);
    const yDomain = [Math.min(0, d3.min(flatData, d => d.value)), Math.max(0, d3.max(flatData, d => d.value))];
    const isStateData = data.some(d => Object.prototype.hasOwnProperty.call(d, 'states') || d.allStates);
    const title = (Array.isArray(allData[i]) ? allData[i][0].title : allData[i].title) || (isStateData ? data[0].metric.geo_name : data[0].metric.name);
    const heightToWidthRatio = Object.prototype.hasOwnProperty.call(options, 'heightToWidthRatio') ? options.heightToWidthRatio : DEFAULT_HEIGHT_TO_WIDTH;
    return {
      ...lodash_1.default.omit(defaultParams, ['title', 'subtitle']),
      title,
      xDomain,
      yDomain,
      hideAxisLabels: Object.prototype.hasOwnProperty.call(options, 'hideAxisLabels') ? options.hideAxisLabels : false,
      hideGridlines: Object.prototype.hasOwnProperty.call(options, 'hideGridlines') ? options.hideGridlines : true,
      areaFill: Object.prototype.hasOwnProperty.call(options, 'areaFill') ? options.areaFill : true,
      heightToWidthRatio: SmallMultiples.heightToWidthRatio(this.chartWidth(), {
        heightToWidthRatio
      }),
      primaryColor: options.primaryColor || null,
      gridColor: options.gridColor || null,
      axisTextColor: options.axisTextColor || null,
      smallTitleColor: options.smallTitleColor || null,
      smallSubtitleColor: options.smallSubtitleColor || null,
      lineSize: options.lineSize || null,
      fontSize: 12,
      titleFontSize: 16,
      tooltipOptions: {},
      showSourcesAndFootnotes: false,
      chartStyle: resolvedChartStyle
    };
  }
  async draw(promises) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const allData = await this.data(promises, options);
    if (!allData) return false;
    const {
      data,
      topMetrics,
      parent
    } = allData;
    const params = {
      expanded: true,
      ...options,
      showSourcesAndFootnotes: options.showSourcesAndFootnotes ?? true,
      ...(0, chart_helpers_1.getDefaultDrawParams)({
        data,
        topMetrics,
        parent,
        options
      }, this.margins)
    };
    const filtered = data.map(d => {
      const dArray = lodash_1.default.flattenDeep([d]);
      return dArray.map(dd => {
        const f = dd.metric.data.filter(_ref2 => {
          let {
            key,
            value
          } = _ref2;
          if (value === null || value === undefined) {
            return false;
          }
          if (params.startDate && key < (0, chart_helpers_1.dateParser)(params.startDate, dd.metric.xType)) {
            return false;
          }
          if (params.endDate && key > (0, chart_helpers_1.dateParser)(params.endDate, dd.metric.xType)) {
            return false;
          }
          return true;
        });
        return {
          ...dd,
          metric: {
            ...dd.metric,
            data: f
          }
        };
      });
    });
    const drawParams = {
      data: filtered,
      topMetrics,
      parent,
      params
    };
    this.drawContent(drawParams);
    return true;
  }
  redrawContent() {
    if (this.cachedParams) {
      this.drawContent(this.cachedParams);
    }
  }
  drawContent(drawParams) {
    this.cachedParams = drawParams;
    const {
      topMetrics,
      parent,
      params
    } = drawParams;
    let {
      data
    } = drawParams;
    if (params.titleVerticalPosition === 'top') {
      this.title.classed('below', false);
      this.container.node().insertBefore(this.title.node(), this.expandable.node());
      this.container.node().insertBefore(this.subtitle.node(), this.expandable.node());
    } else if (params.titleVerticalPosition === 'bottom') {
      this.title.classed('below', true);
      this.container.node().append(this.title.node());
      this.container.node().append(this.subtitle.node());
      this.container.node().append(this.sourceContainer.node());
    }
    if (topMetrics) {
      data = topMetrics.concat(data);
    }
    this.content.selectAll('div.small-multiple').data(data, d => SmallMultiples.id(d)).join(enter => this.createMultiples(enter, params), update => update, exit => this.destroyMultiples(exit)).each((d, i) => {
      const smallData = lodash_1.default.flattenDeep([d]);
      const optionParams = lodash_1.default.omit(this.getDrawParams({
        data: smallData,
        parent,
        options: params
      }, data, i), 'info');
      const smallParams = {
        data: smallData,
        parent,
        params: optionParams
      };
      this.charts[SmallMultiples.id(d)].drawContent(smallParams);
    });
    chart_helpers_1.drawTitle.call(this, this.title, this.subtitle, drawParams);
    if (params.showSourcesAndFootnotes) {
      this.sources.draw(data, params);
    }
    this.drawExpander(data, params, () => this.drawContent(drawParams));
  }
  async drawCanvas(dataPromises) {
    let chartOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let {
      margin = 40,
      width = 720,
      scale = 1,
      showBranding = true,
      xOffset = 0,
      yOffset = 0
    } = arguments.length > 2 ? arguments[2] : undefined;
    let canvas = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (0, canvas_1.createCanvas)(width, width);
    const fetchedData = await this.data(dataPromises, chartOptions);
    if (!fetchedData) return null;
    const {
      data,
      topMetrics,
      parent
    } = fetchedData;
    const params = (0, chart_helpers_1.getDefaultDrawParams)({
      data,
      topMetrics,
      parent,
      options: chartOptions
    }, this.margins);
    if (margin !== null) {
      params.margins.left = margin;
      params.margins.right = margin;
    }
    const heightToWidthRatio = Object.prototype.hasOwnProperty.call(chartOptions, 'heightToWidthRatio') ? chartOptions.heightToWidthRatio : DEFAULT_HEIGHT_TO_WIDTH;
    const logoOffset = 20 + margin + 20;
    const titleOffset = params.titleFontSize * parseFloat(common_module_scss_1.default.chartTitleLineHeight);
    const hasSubtitle = params.subtitle !== '';
    const subtitleOffset = hasSubtitle ? params.subtitleFontSize * parseFloat(common_module_scss_1.default.chartSubtitleLineHeight) : 0;
    const footerHeight = margin + 20;
    let allData;
    if (topMetrics) {
      allData = topMetrics.concat(data);
    } else {
      allData = data;
    }
    const smallTitleHeight = 20;
    this.width = width;
    // canvas manipulation causes side effects
    // eslint-disable-next-line no-param-reassign
    canvas.width = width * scale;
    const chartWidth = width / 2;
    const chartHeight = (chartWidth * heightToWidthRatio + smallTitleHeight) * Math.ceil(allData.length / 2) + params.margins.top;
    // eslint-disable-next-line no-param-reassign
    canvas.height = (chartHeight + logoOffset + titleOffset + subtitleOffset + footerHeight) * scale;
    const context = canvas.getContext('2d');
    context.scale(scale, scale);
    context.fillStyle = 'white';
    context.fillRect(0, 0, canvas.width, canvas.height);
    CanvasDrawer_1.default.drawTitles.call(this, canvas, params, undefined, undefined, undefined, undefined, xOffset, yOffset + logoOffset);
    allData.forEach((d, i) => {
      const smallData = lodash_1.default.flattenDeep([d]);
      const optionParams = this.getDrawParams({
        data: smallData,
        parent,
        options: params
      }, allData, i);
      const linechart = new LineChart_1.default(undefined, true, chartWidth, chartWidth * heightToWidthRatio);
      const smallMultipleXOffset = i % 2 ? chartWidth : 0;
      const smallMultipleYOffset = Math.floor(i / 2) * (chartWidth * heightToWidthRatio + smallTitleHeight) + logoOffset + titleOffset + subtitleOffset + params.margins.top;
      if (i % 2) {
        optionParams.margins.left /= 2;
      } else {
        optionParams.margins.right /= 2;
      }
      CanvasDrawer_1.default.drawTitles(canvas, optionParams, undefined, undefined, undefined, undefined, smallMultipleXOffset, smallMultipleYOffset);
      drawCanvas_1.drawCanvasLineChart.call(linechart, smallData, parent, optionParams, true, canvas, smallMultipleXOffset, smallMultipleYOffset + smallTitleHeight);
    });
    if (showBranding) {
      await CanvasDrawer_1.default.drawLogo(canvas, width, params, margin);
      CanvasDrawer_1.default.drawFooter(canvas, width, chartHeight + logoOffset + titleOffset + subtitleOffset + 20);
    }
    return canvas;
  }
}
exports.default = SmallMultiples;